// @ts-nocheck
import formatDate from "includes/formatDate";
import genRequest from "includes/request";
import generateUUID from "includes/UUID";
import FormOptionModel from "./FormsAnswerOptionsModels/FormOptionModel";
import getQuestionsTypes from "./QuestionsTypes";

/*
	Question Types:
		1 -	Txt
		2 -	ShortText
		3 -	Checkboxes
		4 -	Range
		5 - Buttons
*/

export default class FormQuestionModel {

	constructor(obj, parent) {
		let date = formatDate();

		this.parent = parent;
		this.questionId = (obj?.questionId || obj?.id || null);
		this.formId = (obj?.formId || null);
		this.formSectionId = (obj?.formSectionId || null);
		this.questionDesignId = (obj?.questionDesignId || 1);
		this.type = this.getQuestionsType(this.questionDesignId);
		this.employeeId = (obj?.employeeId || null);
		this.title = (obj?.title || "");
		this.txt = (obj?.txt || "");
		this.imgUrl = (obj?.imgUrl || "");
		this.answerRequired = (obj?.answerRequired || false);
		this.multiple = (obj?.multiple ? obj.multiple : this.type.multiple);
		this.publishedDate = (obj?.publishedDate || date);
		this.position = (obj?.position ? obj.position : this.parent.questions().length);
		this.lastChanged = (obj?.lastChanged || date);
		this.lastChangedAuthorId = (obj?.lastChangedAuthorId || null);
		this.options = [];

		this.tempId = (obj?.tempId || generateUUID());

		if (!this.formSectionId && this.parent)
			this.formSectionId = this.parent.id;

		if (obj && (obj.options)) {
			let opts = obj.options;
			this.options = opts.map((opt) => {
				return (this.newOption(opt));
			});
		} else {
			if ([1, 6].indexOf(this.questionDesignId) !== -1 || !this.options?.length)
			{
				this.options = [
					this.newOption()
				];
			}
		}

		this.elem = null;
	}

	send() {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			this.sendQuestion()
				.then(() => {
					that.sendOptions();
				}, reject).then(() => {
					resolve (true);
				}, reject);
		});
		return (prom);
	}

	sendQuestion() {
		let that = this;
		let req = genRequest(
			"forms/questions" + (this.questionId ? "/" + this.questionId : ""),
			this.values(),
			(this.questionId ? "put" : "post")
		).then((resp) => {
			if (!that.questionId)
				that.id = resp.id || resp.questionId;
		});
		return (req);
	}

	sendOptions() {
		let proms = [];

		for (let option of this.options)
		{
			option.questionId = this.questionId;
			option.formId = this.formId;
			proms.push(option.send());
		}
		return (Promise.all(proms));
	}

	newOption(opt_obj)
	{
		if (!this.type)
			return (false);
		let obj = new FormOptionModel(opt_obj, this);
		obj.tempId = generateUUID();
		this.options.push(obj);
		this.reorderOptions();
		return (obj);
	}

	removeOption(optId) {
		let index = this.options.findIndex((a) => a.id === optId);
		if (index !== -1)
		{
			let deleted = this.options.splice(index, 1);
			this.reorderOptions();
			return (deleted);
		}
		return (false);
	}

	getQuestionsType(type_id)
	{
		let questionsTypes = getQuestionsTypes();
		let type = questionsTypes.find((a) => a.questionDesignId === type_id);
		return (type ? type : false);
	}

	changeType(new_type)
	{
		if (new_type)
		{
			let new_options = [];
			if (this.type.multiple && this.type.multiple === new_type.multiple)
			{
				new_options = this.options.map((answ) => {
					let values = answ.values();
					values.optionId = false;
					values.tempId = false;
					return (new FormOptionModel(values, this));
				});
			} else if (!new_type.multiple)
				new_options.push(new FormOptionModel(null, this));
			this.options.splice(0, this.options.length);
			this.options = new_options;
			this.type = new_type;
			this.multiple = new_type.multiple;
			this.questionDesignId = new_type.questionDesignId;
		}
	}

	moveOption(from_index, to_index) {
		const [removed] = this.options.splice(from_index, 1);
		this.options.splice(to_index, 0, removed);
		this.reorderOptions();
	}

	reorderOptions() {
		let pos = 0;
		for (let x in this.options)
			this.options[x].position = pos++;
	}

	order(new_pos) {
		if (new_pos)
			this.position = new_pos;
		return (this.position);
	}

	move(new_sec) {
		this.parent.removeQuestion(this.questionId, true);
		this.parent = new_sec;
		this.formSectionId = new_sec.id;
		new_sec.questions().push(this);
	}

	clone() {
		return (this.parent.cloneQuestion(this.id));
	}

	delete() {
		return (this.parent.removeQuestion(this.id));
	}

	setSectionId(new_id) {
		if (new_id)
			this.formSectionId = new_id;
		return (this.formSectionId);
	}

	setFormId(value) {
		if (value)
		{
			this.formId = value;
			for (let opt of this.options)
				opt.setFormId(value);
		}
		return (this.formId);
	}

	get parentForm() {
		if (!this.parent)
			return (false);
		return (this.parent.parentForm);
	}

	get parentSection() {
		return (this.parent);
	}

	get id() {
		return (this.questionId ? this.questionId : this.tempId);
	}

	set id(value) {
		this.questionId = value;
		for (let opt of this.options)
			opt.setQuestionId(value);
	}

	checkValues() {
		if (!this.title?.length)
			return ({
				error: "FORM_QUESTION_EMPTY_TITLE",
				selector: "[data-form-question-id='" + this.id + "'] .question-title-cont"
			});
		if (this.multiple)
		{
			if (!this.options.length)
				return ({
					error: "FORM_MULTIPLE_ANSWERS_MISSING_OPTION",
					selector: "[data-form-question-id='" + this.id + "'] .question-options-cont"
				});
			for (let opt of this.options)
				if (!opt.value())
					return ({
						selector: "[data-form-option-id='" + opt.id + "']",
						error: "FORM_ANSWER_MISSING_VALUE"
					});
		}
		return (true);
	}

	values(with_opts) {
		let obj = {
			formId: this.formId,
			formSectionId: this.formSectionId,
			questionDesignId: this.questionDesignId,
			type: this.type,
			employeeId: this.employeeId,
			title: this.title,
			txt: this.txt,
			imgUrl: this.imgUrl,
			answerRequired: this.answerRequired,
			multiple: this.multiple,
			publishedDate: this.publishedDate,
			position: this.position,
			lastChanged: this.lastChanged,
			lastChangedAuthorId: this.lastChangedAuthorId,
		};
		if (this.questionId)
			obj.questionId = this.questionId;
		if (with_opts)
			obj.options = this.options.map(ans => {
				return (ans.values());
			});
		return (obj);
	}
}
